import { RefObject, useEffect, useRef, useState } from "react";

interface Props {
  children: (
    textInput: RefObject<HTMLInputElement | null>,
    isFocused?: boolean
  ) => React.ReactNode | null;
}

const FocusTextInput: React.FC<Props> = ({ children }) => {
  const textInput = useRef<HTMLInputElement>(null);
  const [isFocused, setFocused] = useState(false);

  const onKeyFunc: (this: Window, ev: KeyboardEvent) => any = (event) => {
    const curElement = document.activeElement;
    const inputTagNames = ["input", "select", "button", "textarea"];

    if (
      !(
        inputTagNames.find(
          (name) => name == curElement?.tagName.toLowerCase()
        ) || curElement?.classList.contains("ProseMirror")
      ) &&
      event.key == "/" &&
      textInput.current != document.activeElement
    ) {
      event.preventDefault();
      textInput.current?.focus();
    }
  };

  const onFocus: (this: HTMLInputElement, ev: FocusEvent) => any = (event) => {
    setFocused(true);
  };

  const onBlur: (this: HTMLInputElement, ev: FocusEvent) => any = (event) => {
    setFocused(false);
  };

  useEffect(() => {
    window.addEventListener("keydown", onKeyFunc);

    textInput.current?.focus();

    textInput.current?.addEventListener("focus", onFocus);
    textInput.current?.addEventListener("blur", onBlur);

    return () => {
      window.removeEventListener("keydown", onKeyFunc);
      textInput.current?.removeEventListener("focus", onFocus);
      textInput.current?.removeEventListener("blur", onBlur);
    };
  }, []);

  // useEffect(() => {
  //   setFocused(textInput.current?.focu)
  // }, [textInput.current?.focus()])

  // tell React that we want to associate the <input> ref
  // with the `textInput` that we created in the constructor
  return <>{children(textInput, isFocused)}</>;
};

export default FocusTextInput;
